import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import manageUser from './views/manageUser.vue'
import manageUserTypes from './views/manageUserType.vue'
import formViewer from './views/formViewer.vue'
import dataFormViewer from './views/DataFormViewer.vue'
import formsManager from './views/formsManager'
import loginPage from './views/Login'
import dashboard from './views/Dashboard'



Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: loginPage
    },
    {
      path: '/home',
      component: dashboard,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/manageUser',
          name: 'manageUser',
          component: manageUser
        },
        {
          path: '/manageUserTypes',
          name: 'manageUserTypes',
          component: manageUserTypes
        },
        {
          path: '/formViewer',
          name: 'formViewer',
          component: formViewer
        },
        {
          path: '/formsManager',
          name: 'formsManager',
          component: formsManager
        },
        {
          path: '/dataFormViewer',
          name: 'dataFormViewer',
          component: dataFormViewer
        },
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
      ]


    }
  ]
});

router.beforeEach((to, from, next) => {

  //console.log(" router "+JSON.stringify(to));
  next();   
});



export default router;